import ToastContent from '@trackman/web-shared-components/components/Toast/ToastContent';
import { ToastProps } from '@trackman/web-shared-components';
import { useNotificationsStore } from 'stores/NotificationsStore';

export const Notifications = () => {
  const { toasts, handleOnClose } = useNotificationsStore();

  return (
    <div
      style={{
        top: '24px',
        right: '24px',
        zIndex: 2002,
        position: 'fixed',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      {toasts &&
        toasts.map((toast: ToastProps, index: number) => {
          return (
            <ToastContent
              onClose={() => handleOnClose(toast.id ? toast.id : '')}
              key={index}
              severity={toast.severity}
              header={toast.header}
              message={toast.message}
              margin='8px'
            />
          );
        })}
    </div>
  );
};
